const randomCodeGenerator = () => {
    /**
     * Generate a random 6-character code
     * 
     * @returns {string} - 6-character code
     */
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < 6; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export { randomCodeGenerator };
